import LocalizedStrings from "react-localization";

const localizedStrings = new LocalizedStrings({
  es: {
    // General
    appName: "factu.mx",
    url_logo_colored_svg: "https://static.dev.factu.mx/assets/logo_color.svg",

    // Shared Titles
    titleTerms: "Términos",
    titlePrivacy: "Privacidad",

    // Alert Generic Strings
    alertOops: "Oops!",
    alertOk: "OK",
    alertCancel: "Cancel",
    alertUnexpectedError: "¡Ups! Ocurrió un error inesperado.",
    alertAccountDeletionOk: "Se eliminó tu cuenta exitosamente.",
    alertInvalidAccountDeleteOTP:
      "No se pudo verificar tu identidad. Por favor verifica el código.",
    alertUserSessionExpired: "Tu sesión ha expirado.",
    alertRfcManualUpdateTimeoutWindowBlock:
      "Aún no transcurre suficiente tiempo desde tu útlima actualización.",
    alertRfcManualUpdateSuccess: "¡Tus CFDIs se están actualizando!",
    alertRfcManualUpdateComplete: "¡Tus CFDIs se actualizaron!",
    alertSubscriptionResumedSuccess: "Tu subscripción se reanudó exitosamente.",
    alertSubscriptionCancelSuccess: "Tu subscripción se canceló exitosamente.",
    alertRfcRefreshScheduleUpdateSuccess:
      "Tu horario de actualización se actualizó exitosamente.",
    alertCreditCouponInvalid: "El código del cupón no es válido.",
    alertCreditCouponAlreadyApplied: "El código del cupón ya fue aplicado.",
    alertCreditCouponClassAlreadyApplied:
      "Un cupón de este tipo ya fue aplicado.",
    alertCreditCouponOk: "El cupón se aplicó exitosamente.",
    alertFeedbackSentSuccess: "¡Gracias! Tu retroalimentación ha sido enviada.",
    alertPayment3DSFailed:
      "No se pudo verificar tu método de pago. Por favor intenta de nuevo.",

    // URLs
    urlPrivacy: "https://factu.mx/privacidad",
    urlTerms: "https://factu.mx/terminos",

    // Validation
    validationEmailRequired: "El correo electrónico no puede estar vacío.",
    validationPasswordRequired: "La contraseña no puede estar vacía.",
    validationRFCNotFound: "El RFC no fue encontrado.",

    //Errors
    errorStripePortalURLFailed:
      "Error obteniendo el enlace a tu cuenta de facturación.",

    // Form
    formEmail: "Correo Electrónico",
    formPassword: "Contraseña",

    // Login
    loginTitle: "Iniciar Sesión",
    loginButton: "Iniciar Sesión",
    loginForgotPassword: "Forgot your password?",
    loginCreateAccountTitle: "New here?",
    loginCreateAccountButton: "Crear Cuenta",
    loginIncorrectCredentials:
      "¡Ups! El correo electrónico o contraseña son incorrectos.",

    //Register
    registerEmailAlreadyExists:
      "¡Ups! El correo electrónico que usaste ya está registrado.",
    registerInvalidVerificationToken:
      "¡Ups! El código de verificación es inválido.",
  },
});

export default localizedStrings;
